import { createSlice } from "@reduxjs/toolkit";
import { api, apiErrorsHandler } from "../../api/httpclient";
import { themes } from "../../sass/themes";

const currentThemeSlice = createSlice({
  name: "currentTheme",
  initialState: themes["2"],
  processing: false,
  processingText: "",
  reducers: {
    setCurrentTheme: (state, action) => ({ ...action.payload }),

    setProcessing: (state, action) => {
      //payload: {processing=true, processingText=false}, when processing is false, processingText is ""
      const { processing = true, processingText = "" } = action.payload;

      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },
  },
});

export const { setCurrentTheme, setProcessing } = currentThemeSlice.actions;

export default currentThemeSlice.reducer;

export const setUserTheme =
  (themeId, isRightToLeft, sideBarType, langId, t) =>
  async (dispatch, getState) => {
    //payload the entity id
    dispatch(
      setProcessing({
        processing: true,
        processingText: t("slices.settingTheme"),
      })
    );
    try {
      var response = await api({
        url: "/auth/setusertheme",
        method: "post",
        data: {
          themeId: themeId,
          isRightToLeft: isRightToLeft,
          sideBarType: sideBarType,
          languageId: langId,
        },
        //headers:{'h':'1'}
      });

      dispatch(setProcessing({ processing: false }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };
